module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "periode-form"
    }
  }, [_c('v-card', {
    attrs: {
      "text": ""
    }
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Nama Periode *\n                ")]), _vm._v(" "), _c('v-text-field', {
    ref: "name",
    attrs: {
      "id": "periode_name",
      "placeholder": "Nama Periode",
      "rules": _vm.nameRules,
      "outlined": ""
    },
    model: {
      value: (_vm.periode.name),
      callback: function($$v) {
        _vm.$set(_vm.periode, "name", $$v)
      },
      expression: "periode.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Deskripsi\n                ")]), _vm._v(" "), _c('v-textarea', {
    ref: "description",
    attrs: {
      "id": "periode_deskripsi",
      "placeholder": "Deskripsi Periode",
      "rules": _vm.descriptionRules,
      "outlined": ""
    },
    model: {
      value: (_vm.periode.description),
      callback: function($$v) {
        _vm.$set(_vm.periode, "description", $$v)
      },
      expression: "periode.description"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Mulai *\n                            ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "periode_start_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "outlined": "",
            "readonly": ""
          },
          model: {
            value: (_vm.periode.start_date),
            callback: function($$v) {
              _vm.$set(_vm.periode, "start_date", $$v)
            },
            expression: "periode.start_date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.menuStart = false
      }
    },
    model: {
      value: (_vm.periode.start_date),
      callback: function($$v) {
        _vm.$set(_vm.periode, "start_date", $$v)
      },
      expression: "periode.start_date"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Berakhir *\n                            ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "periode_end_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "outlined": "",
            "readonly": ""
          },
          model: {
            value: (_vm.periode.end_date),
            callback: function($$v) {
              _vm.$set(_vm.periode, "end_date", $$v)
            },
            expression: "periode.end_date"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.menuEnd = false
      }
    },
    model: {
      value: (_vm.periode.end_date),
      callback: function($$v) {
        _vm.$set(_vm.periode, "end_date", $$v)
      },
      expression: "periode.end_date"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "id": "periode_simpan",
      "color": "blew",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n                Selanjutnya\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a371b26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_meter/components/PeriodeForm.vue
// module id = 955
// module chunks = 1